import { Checkbox, FormItemProps } from 'antd';
import FormItem from 'components/form/FormItem';
import React from 'react';

export interface IFormCheckbox extends FormItemProps {
  name?: string | string[];
  label?: React.ReactNode;
  children?: React.ReactNode | string;
  defaultChecked?: boolean;
  disabled?: boolean;
}

export default function FormCheckbox({
  noStyle,
  name,
  label,
  children,
  defaultChecked,
  disabled,
  ...props
}: IFormCheckbox) {
  return (
    <FormItem
      noStyle={noStyle}
      valuePropName="checked"
      label={label}
      name={name}
      {...props}
    >
      <Checkbox
        className="fw-600"
        defaultChecked={defaultChecked}
        disabled={disabled}
      >
        {children}
      </Checkbox>
    </FormItem>
  );
}
